import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, FormControlDirective } from '@angular/forms';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ClaimDataService } from 'src/app/feature-module/claims-data/service/claim-data.service';
import { ControlSettings } from '../../ControlSettings';
import { AutoComplete } from '../operators/autocomplete';

@Component({
  selector: 'claim-tag-combo-select-ctrl',
  templateUrl: './claim-tag-combo-select.component.html',
  styleUrls: ['./claim-tag-combo-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: ClaimTagComboSelectComponent,
    multi: true
  }]
})
export class ClaimTagComboSelectComponent implements ControlValueAccessor, OnInit {

  constructor(protected controlContainer: ControlContainer,
    private claimDataService: ClaimDataService) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;

  @Input() public formControlName: string;
  @Input() caption: string;
  @Input() allowCustom = true;

  @Input() settings: ControlSettings = {};
  defaultSettings: ControlSettings = { fxFill: false, readonly: false };

  valuesList$: Observable<string[]>;
  term$ = new BehaviorSubject<string>('');

  @Output() valueChangeEvent = new EventEmitter<any>();

  ngOnInit(): void {

    Object.assign(this.defaultSettings, this.settings);
    this.settings = this.defaultSettings;
    this.valuesList$ = this.term$.pipe(
      AutoComplete.autocomplete(500, (term => term ? this.claimDataService.getClaimTags(term) : of<string[]>([]))));
    this.filterChange(this.control.value);
  }

  onChange(value: any) {
    this.valueChangeEvent.emit(value);
  }

  public filterChange(filter: any): void {
    this.term$.next(filter);
    this.control.markAsTouched();
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }

  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    if (obj) {
      this.filterChange(obj);
    }

    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }
}
